"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getObjectIdPageProp = exports.OBJECT_ID_PROP = void 0;
const libs_next_utils_1 = require("@hotelplan/libs.next-utils");
exports.OBJECT_ID_PROP = '_oid';
exports.getObjectIdPageProp = (0, libs_next_utils_1.createPagePropGetter)(exports.OBJECT_ID_PROP, { id: '', objectId: '', objectType: '' });
//# sourceMappingURL=ObjectId.utils.js.map